import axios from 'axios';
import store from '@/store';
import { useSnackBar } from '@/composition/snackBar';
// create an axios instance
const service = axios.create({
    baseURL: '/api'
    // timeout: 10000 // request timeout
});
// request interceptor
service.interceptors.request.use(config => {
    // do something before request is sent
    if (store.getters.accessToken) {
        config.headers['Authorization'] = 'Bearer ' + store.getters.accessToken;
    }
    return config;
}, error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
});
// response interceptor
service.interceptors.response.use(response => {
    return response.data;
}, error => {
    console.log('에러 => ' + error); // for debug
    const { open } = useSnackBar();
    open({ text: 'An error occurred during processing.', color: 'error' });
    return Promise.reject(error);
});
export default service;
